import Backdrop from "src/Candidate/molecules/Backdrop";
import Image from "next/image";
import Loading from "public/images/loading.gif";

function LoadingSpinner(): JSX.Element {
  return (
    <div role="status">
      <div>
        <Backdrop>
          <div className="w-full flex place-content-center">
            <Image src={Loading} width={106} height={106} alt="loading" />
          </div>
        </Backdrop>
      </div>
    </div>
  );
}

export default LoadingSpinner;
